import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import { useSnackbar } from "notistack";
import React, { useEffect, useState,useRef  } from "react";
import { config } from "../App";
import Footer from "./Footer";
import Header from "./Header";
import "./Products.css";
import ProductCard from "./ProductCard"

import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';
import Cart,{generateCartItemsFrom} from "./Cart"
// Definition of Data Structures used
/**
 * @typedef {Object} Product - Data on product available to buy
 * 
 * @property {string} name - The name or title of the product
 * @property {string} category - The category that the product belongs to
 * @property {number} cost - The price to buy the product
 * @property {number} rating - The aggregate rating of the product (integer out of five)
 * @property {string} image - Contains URL for the product image
 * @property {string} _id - Unique ID for the product
 */

// const Item = styled(Paper)(({ theme }) => ({
//   backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
//   ...theme.typography.body2,
//   padding: theme.spacing(1),
//   textAlign: 'center',
//   color: theme.palette.text.secondary,
// }));

const Products = () => {
    const { enqueueSnackbar } = useSnackbar();
    const [loading,setLoading]=useState(false);
    const [productsList, setProductsList] = useState([]);
    const [cartAllProductsList, setCartAllProductsList] = useState([]);
    // const [searchedProductsList, setSearchedProductsList] = useState([]);
    const [search,setSearch]=useState("");
    const [debounceTimeout, setDebounceTimeout] = useState(0);
    // const mountedRef = useRef(true);
    const [ productNotFound, setProductNotFound ] = useState(false);
    const [cartData,setCartData]=useState([]);
    const [cartProducts,setCartProducts]=useState([]);
    const mountedRef = useRef(true)

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Fetch products data and store it
  /**
   * Make API call to get the products list and store it to display the products
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on all available products
   *
   * API endpoint - "GET /products"
   *
   * Example for successful response from backend:
   * HTTP 200
   * [
   *      {
   *          "name": "iPhone XR",
   *          "category": "Phones",
   *          "cost": 100,
   *          "rating": 4,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "v4sLtEcMpzabRyfx"
   *      },
   *      {
   *          "name": "Basketball",
   *          "category": "Sports",
   *          "cost": 100,
   *          "rating": 5,
   *          "image": "https://i.imgur.com/lulqWzW.jpg",
   *          "_id": "upLK9JbQ4rMhTwt4"
   *      }
   * ]
   *
   * Example for failed response from backend:
   * HTTP 500
   * {
   *      "success": false,
   *      "message": "Something went wrong. Check the backend console for more details"
   * }
   */
  const performAPICall = async () => {
    setLoading(true);
    await axios.get(config.endpoint+"/products")
    .then((res)=>{
        console.log("products list",res.data);
        setProductsList(res.data);
        setCartAllProductsList(res.data);
        setLoading(false);
      })
    .catch((err)=>{
      if (err.response)
        {
          console.log("Something went wrong. Check that the backend is running, reachable and returns valid JSON.")
            setLoading(false)
            enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
            {
              variant: "error"
            });
        }
    })
      
  };



//fetch cart
// const generatingCartProducts=()=>
// {
//   let cartProds=generateCartItemsFrom(cartData,productsList);
//   // setCartProducts(cartProds);
//   console.log(cartProds);
// }
const fetchCart = async () =>{
  try{
    const res = await axios.get(`${config.endpoint}/cart`,{
                  headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                  }
                })
      setCartData(res.data);
      
  }
  catch( error){
    // enqueueSnackbar('Network error',{variant:'error'});
  }

}

useEffect(() => {
  performAPICall();
  fetchCart();
}, []);
// useEffect(() => {
//   if(localStorage.getItem('username')==null)
//   {
//     return;
//   }
//   else if(localStorage.getItem('username'))
//   {
//     fetchCart();
//     generateCartItemsFrom(cartData,cartAllProductsList);
//   }
//   return () => { 
//     mountedRef.current = false
//   }
// }, [localStorage.getItem('username')]);

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Implement search logic
  /**
   * Definition for search handler
   * This is the function that is called on adding new search keys
   *
   * @param {string} text
   *    Text user types in the search bar. To filter the displayed products based on this text.
   *
   * @returns { Array.<Product> }
   *      Array of objects with complete data on filtered set of products
   *
   * API endpoint - "GET /products/search?value=<search-query>"
   *
   */
  const performSearch = async (text) => {
    text=text.trim();
    console.log("perform search has been called successfully. searchText=",text);
    if(text!=="")
    {
      await axios.get(config.endpoint+"/products/search?value="+`${text}`)
    .then((res)=>{
        console.log(res.data);
        setProductsList(res.data);
        // setLoading(false);
      })
    .catch((err)=>{
      if (err.response)
        {
          setProductsList([])
          console.log("No products found")
            // setLoading(false)
            // enqueueSnackbar("Something went wrong. Check that the backend is running, reachable and returns valid JSON.",
            // {
            //   variant: "error"
            // });
        }
    })
    }
    else{
      performAPICall();
    }
  };

  // TODO: CRIO_TASK_MODULE_PRODUCTS - Optimise API calls with debounce search implementation
  /**
   * Definition for debounce handler
   * With debounce, this is the function to be called whenever the user types text in the searchbar field
   *
   * @param {{ target: { value: string } }} event
   *    JS event object emitted from the search input field
   *
   * @param {NodeJS.Timeout} debounceTimeout
   *    Timer id set for the previous debounce call
   *
   */
  const handleChange=(e) => {
    setSearch(e.target.value)
    console.log(search);
  }
  // const debounceSearch = (event, debounceTimeout) => {
  //   setSearch(event.target.value);
  //   const newSearch=search;
  //   if(newSearch.length>0)
  //   {
  //     if (debounceTimeout) {
  //       clearTimeout(debounceTimeout);
  //     }
  //     const newTimeout = setTimeout(() => performSearch(newSearch), 500);
  //     setDebounceTimeout(newTimeout);
  //   }
  // };



  const dummyproduct=
  {
  "name":"Tan Leatherette Weekender Duffle",
  "category":"Fashion",
  "cost":150,
  "rating":4,
  "image":"https://crio-directus-assets.s3.ap-south-1.amazonaws.com/ff071a1c-1099-48f9-9b03-f858ccc53832.png",
  "_id":"PmInA797xJhMIPti"
  };

  

useEffect(() => {
  if (debounceTimeout !== 0) {
    clearTimeout(debounceTimeout);
  }
  const newTimeout = setTimeout(() => performSearch(search), 500);
  setDebounceTimeout(newTimeout);
}, [search]);


const isItemInCart = (id) => {
  return storeCardItem.some( item => item._id === id );
}

const updateCart = async (productId,quantity) => {
  const res = await axios.post(`${config.endpoint}/cart`, {
    productId : productId , qty : quantity
  }, {
    headers: {
      'Authorization': `Bearer ${localStorage.getItem('token')}` 
    }
  })
  setCartData(res.data);
}

const handleAddToCart = ( _id ) => {
  console.log("Inside handle to cart")
  if( !localStorage.getItem('token') ){
    console.log("Token not found, must log in");
    enqueueSnackbar("Login to add an item to the Cart",{variant:"warning"});
    return;
  }
  if( isItemInCart(_id) ){
    console.log("Item already exists inside Cart");
    enqueueSnackbar("Item already in cart. Use the cart sidebar to update quantity or remove item.",{variant:"warning"});
    return;
  }else{
    console.log("Updating Cart...");
    updateCart(_id,1)
  }
}

const handleQuantity = ( id , quantity) =>{   
  updateCart(id,quantity);
}


const storeCardItem = generateCartItemsFrom(cartData,cartAllProductsList);
const child=(
  <TextField
        className="search-desktop"
        size="small"
        fullWidth
        value={search}
        // onChange={(e)=>{ debounceSearch(e,debounceTimeout)}}
        onChange={(e)=>{handleChange(e)}}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end"
            onClick={()=>{
                console.log(search,"Search Clicked!");
                performSearch(search);
              }}
            >
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
      />
);
  return (
    <div>
      <Header children={child}>
        {/* TODO: CRIO_TASK_MODULE_PRODUCTS - Display search bar in the header for Products page */}
      </Header>

      {/* Search view for mobiles */}
      <TextField
        className="search-mobile"
        size="small"
        fullWidth
        value={search}
        // onChange={(e)=>{debounceSearch(e,debounceTimeout)}}
        onChange={(e)=>{handleChange(e)}}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end"
            onClick={()=>{
                console.log(search,"Search Clicked!");
                performSearch(search);
              }}
            >
              <Search color="primary" />
            </InputAdornment>
          ),
        }}
        placeholder="Search for items/categories"
        name="search"
      />


       {/* for logged in users */}
      {localStorage.getItem('username')!==null && 
        <Grid container>
          <Grid item className="product-grid" md={9} xs={12}>
            <Box className="hero">
              <p className="hero-heading">
                India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
                to your door step
              </p>
            </Box>
          {/* </Grid> */}
        {/* <ProductCard product={dummyproduct}/> */}
        {loading && 
           <Grid container
           spacing={0}
           alignItems="center"
           justifyContent="center"
           className="loading"
           style={{display:"flex",flexDirection: "column"}}>
               <CircularProgress ></CircularProgress><br />
               <p>Loading Products...</p>
           </Grid>
        }
        <Box sx={{ flexGrow: 1 , margin:"7px"}}>
           {/* <Grid container spacing={2}> */}
             {/* <Grid item xs={2} md={3}>  */}
             <Grid container
           spacing={2}
           alignItems="center"
           justifyContent="center">
             {!loading && productsList.length>0 &&
                       productsList.map((product)=>(
                         <Grid item xs={12} sm={6} md={3} key={product._id}>
                              <ProductCard 
                                product={product}
                                handleAddToCart={()=>handleAddToCart(product._id)} 
                                />
                         </Grid>
                       ))
               }
               
               {!loading && productsList.length==0 &&
                                   <Grid container
                                   spacing={0}
                                   alignItems="center"
                                   justifyContent="center"
                                   className="loading"
                                   style={{display:"flex",flexDirection: "column"}}>
                                       <SentimentDissatisfied ></SentimentDissatisfied><br />
                                       <p>No products found</p>
                                   </Grid>
               }
           </Grid>
                 
               {/* </Grid>
             </Grid> */}
           </Box>
      </Grid>
          <Grid item className="cart-grid" md={3} xs={12}>
          <Cart 
              products={cartAllProductsList} 
              items={storeCardItem} 
              handleQuantity={handleQuantity}
              />

          </Grid>
        </Grid>
      }
      {/* for logged out users */}
      {localStorage.getItem('username')==null && 
        <Grid container>
          <Grid item className="product-grid">
            <Box className="hero">
              <p className="hero-heading">
                India’s <span className="hero-highlight">FASTEST DELIVERY</span>{" "}
                to your door step
              </p>
            </Box>
          </Grid>
        {/* <ProductCard product={dummyproduct}/> */}
        {loading && 
           <Grid container
           spacing={0}
           alignItems="center"
           justifyContent="center"
           className="loading"
           style={{display:"flex",flexDirection: "column"}}>
               <CircularProgress ></CircularProgress><br />
               <p>Loading Products...</p>
           </Grid>
        }
        <Box sx={{ flexGrow: 1 , margin:"7px"}}>
           {/* <Grid container spacing={2}> */}
             {/* <Grid item xs={2} md={3}>  */}
             <Grid container
           spacing={2}
           alignItems="center"
           justifyContent="center">
             {!loading && productsList.length>0 &&
                       productsList.map((product)=>(
                         <Grid item xs={12} sm={6} md={3} key={product._id}>
                           <ProductCard 
                                product={product}
                                handleAddToCart={()=>handleAddToCart(product._id)} 
                                />
                         </Grid>
                       ))
               }
               
               {!loading && productsList.length==0 &&
                                   <Grid container
                                   spacing={0}
                                   alignItems="center"
                                   justifyContent="center"
                                   className="loading"
                                   style={{display:"flex",flexDirection: "column"}}>
                                       <SentimentDissatisfied ></SentimentDissatisfied><br />
                                       <p>No products found</p>
                                   </Grid>
               }
           </Grid>
                 
               {/* </Grid>
             </Grid> */}
           </Box>
      </Grid>
      // </Grid>
      }




      <Footer />
    </div>
  );
};

export default Products;
